import styled, { AnyStyledComponent } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

import LeftArrowIcon from '../../assets/images/red-arrow-left.svg'
import RightArrowIcon from '../../assets/images/red-arrow-right.svg'
import QuotationMark from '../../assets/images/quotation.svg'

export const Section = styled.section`
    padding: ${props => props.theme.spacing.xxLarge} 0 3.5rem;
    background-color: ${props => props.theme.colors.tfwBlack3};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 4.375rem 0 5.625rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 4.375rem 1.25rem 8.125rem;
    }
`

export const Title = styled.h2`
    padding: 0 ${props => props.theme.spacing.xSmall};
    margin: 0;
    font-size: 1.75rem;
    line-height: normal;
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-weight: bold;
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 3rem;
        font-size: 2.125rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 10.625rem;
        font-size: 2.125rem;
    }
`

export const RatingContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    align-items: ${props => props.theme.style.alignItems.center};
    margin-top: 1.875rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 1.25rem;
    }
`

export const RatingDescription = styled.div`
    margin-top: 0.625rem;
    font-size: ${props => props.theme.typography.font.size.medium};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 300;
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.tfwBlack87};
`

export const CardContainer = styled.div`
    margin: 1.875rem 0.46875rem;
    min-height: 32.8125rem;
    display: grid;
    background-color: ${props => props.theme.colors.white};
    border-radius: 0 0.375rem 0.375rem 0;
    @media only screen and (min-width: 500px) {
        min-height: 38rem;
    }

    @media only screen and (min-width: 650px) {
        min-height: 42.8125rem;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        min-height: 18.125rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        background-color: transparent;
        min-height: auto;
        margin: 0;
        padding-top: 0.5rem;
    }
    @media only screen and (min-width: 1095px) {
        width: 875px;
        margin-left: auto;
        margin-right: auto;
    }
`

export const SliderContainer = styled.ul`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.row};
    align-items: ${props => props.theme.style.alignItems.center};
    justify-content: ${props => props.theme.style.justifyContent.center};
    overflow: hidden;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin-bottom: -3.125rem;
    }
`

export const Dot = styled.div<{ selected: boolean }>`
    border-radius: 0.3125rem;
    height: 0.625rem;
    width: 0.625rem;
    background-color: ${props => (props.selected ? props.theme.colors.tfwRed : props.theme.colors.tfwBlack12)};
`

export const CardContent = styled.div`
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: ${({ theme }) => theme.style.display.flex};
        flex-direction: ${({ theme }) => theme.style.flexDirection.rowReverse};
        justify-content: ${({ theme }) => theme.style.justifyContent.spaceBetween};
        height: ${({ theme }) => theme.layout.fill};
    }
`
export const TestimonialImage = styled.img`
    width: ${({ theme }) => theme.layout.fill};
    border-radius: ${({ theme }) => `${theme.typography.border.radius.small} ${theme.typography.border.radius.small}`} 0
        0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 18.75rem;
        height: ${({ theme }) => theme.layout.fill};
        object-fit: cover;
        border-radius: 0
            ${({ theme }) => `${theme.typography.border.radius.small} ${theme.typography.border.radius.small}`} 0;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        box-shadow: ${props => props.theme.spacing.xSmall} ${props => props.theme.spacing.medium} 1rem 0 #0000001a;
        border-radius: ${({ theme }) => `${theme.typography.border.radius.small}`};
    }
`

export const ContentContainer = styled.div`
    padding: 1.25rem;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: ${({ theme }) => theme.style.display.flex};
    }
`

export const GreetingIcon = styled(QuotationMark as AnyStyledComponent)`
    width: ${props => props.theme.spacing.medium};
    height: ${props => props.theme.spacing.medium};
`

export const DescriptionText = styled.div`
    margin-bottom: ${props => props.theme.spacing.medium};
    font-size: ${props => props.theme.typography.font.size.large};
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-weight: normal;
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.xLarge};
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin-bottom: 1.5625rem;
        font-size: ${({ theme }) => theme.typography.font.size.xLarge};
        font-weight: 300;
    }
`
export const NameText = styled.div`
    font-size: ${props => props.theme.typography.font.size.small};
    line-height: ${props => props.theme.typography.font.size.large};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: bold;
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.medium};
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.medium};
        margin-bottom: 0.5rem;
    }
`
export const DesignationText = styled.a`
    font-size: ${props => props.theme.typography.font.size.small};
    line-height: ${props => props.theme.typography.font.size.large};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: normal;
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.medium};
    }
`

export const LeftArrow = styled(LeftArrowIcon as AnyStyledComponent)`
    display: ${({ theme }) => theme.style.display.block};
    width: 2.5rem;
    height: 4rem;
    cursor: pointer;
`
export const RightArrow = styled(RightArrowIcon as AnyStyledComponent)`
    display: block;
    width: 2.5rem;
    height: 4rem;
    cursor: pointer;
`
export const CarouselContainer = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        min-width: 55rem;
        max-width: 80%;
    }
`
export const TestimonialContainer = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: ${({ theme }) => theme.style.display.flex};
        align-items: ${({ theme }) => theme.style.alignItems.center};
        justify-content: ${({ theme }) => theme.style.justifyContent.spaceBetween};
        max-width: 1110px;
        margin: 4.375rem auto 0;
    }
`

export const ImageContainer = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        border-radius: ${({ theme }) => `${theme.typography.border.radius.small}`};
        padding: 0 1.25rem 2.5rem 0;
    }
`

export const QuotationMarkContent = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding-top: 0;
        margin: -0.1rem 0.3125rem 0 0;
    }
`
